import { post } from "./client";
import { url } from "./common";

// ---- Response shapes ----

export type PeertubeVideoUrlResponse = { videoUrl: string };

export type S3FileUrlResponse = { fileUrl: string };

export type PeertubeUploadTokenResponse = {
  token: string;
  channelId: number;
};

// ---- Models ----

export const mediaModels = {
  PEERTUBE_VIDEO_FILE_URL: (videoId: string) =>
    url<PeertubeVideoUrlResponse>(`/peertube/video/${videoId}/hls`),
  S3_FILE_URL: (filepath: string) =>
    url<S3FileUrlResponse>(`/upload?filepath=${encodeURIComponent(filepath)}`),
};

// ---- Mutations ----

export const mediaMutations = {
  createPeertubeToken: () =>
    post<PeertubeUploadTokenResponse>("/peertube/create-upload-token", {}, []),
};
